import httpRequest from "../ajax";

export const idealTalentsService = {
  /**
   * Fetch ideal talents for a specific job
   * @param {number} jobId - The ID of the job posting
   * @param {number} page - Page number (starts from 1)
   * @param {number} limit - Number of results per page
   * @returns {Promise} - API response with ideal talents data
   */
  fetchIdealTalents: async (jobId, page = 1, limit = 50) => {
    try {
      const response = await httpRequest(
        "get",
        `/recruiter/insight/${jobId}/ideal-talents/${page}/${limit}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Invite talents to apply for a job
   * @param {number} jobId - The ID of the job posting
   * @param {Array<number>} talentIds - Array of talent IDs to invite
   * @returns {Promise} - API response with invitation results
   */
  inviteTalents: async (jobId, talentIds) => {
    try {
      const response = await httpRequest(
        "post",
        `/recruiter/insight/${jobId}/ideal-talents/invite`,
        {
          job_id: jobId,
          talent_ids: talentIds,
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default idealTalentsService;
